import React from "react";
import PercentageDisplay from "../../../../components/percentageDisplay/percentageDisplay";
import PropTypes from "prop-types";
import { calculatePercentage } from "../../../../utils/calculatePercentage";
import { useSelector } from "react-redux";

const Scorecard = ({ scorecards }) => {
  return (
    <>
      {scorecards &&
        scorecards.map((scorecard, index) => {
          return (
            <div className="scorecards__item" key={index}>
              <div className="name">{scorecard.name}</div>
              <div className="value">{scorecard.value}</div>
              <SubScorecardPercent percent={scorecard.percent} />
            </div>
          );
        })}
    </>
  );
};

const SubScorecardPercent = ({ percent }) => {
  const { currentType } = useSelector((state) => state.loginReport);

  return percent !== undefined ? (
    <div className="sub-scorecard">
      <div className="sub-scorecard__name">
        {currentType === "User" ? "Percent of Users" : "Percent of Stores"}
      </div>
      <div className="sub-scorecard__value">
        <PercentageDisplay
          value={Math.round(calculatePercentage(percent, 1))}
          disableAnimation
          color={"white"}
          size="13px"
        />
      </div>
    </div>
  ) : (
    ""
  );
};

Scorecard.propTypes = {
  scorecards: PropTypes.array
};
SubScorecardPercent.propTypes = {
  percent: PropTypes.number
};

export default Scorecard;
